import { createReduxStore } from "src/store/redux_store";

const OnboardingStore = createReduxStore({
  name: "onboarding",
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
});

export { OnboardingStore };
